/**
 * To communicate with IB from React: use onStart, setTitle, setHeight, showModal, setContainerConfig
 * Back to communicate with React from IB: use onStart_callback, showModal_callback
 */
import { SF_COMMUNICATION } from "../constants";
import {
  IContainerConfig,
  IModalData,
  ISFCommunicationHelper,
  IStartupData,
} from "../interfaces";

/* Error message generation */
const getErrorMessage = (method: string, errorMessage: string) =>
  `${method}: ${errorMessage}`;

export class SFCommunicationHelper implements ISFCommunicationHelper {
  onStart = () => {
    try {
      window.parent.postMessage(
        {
          eventType: SF_COMMUNICATION.EVENTS.ON_START,
        },
        window.configuration.IB_URL
      );
    } catch (error: any) {
      throw new Error(
        getErrorMessage(SF_COMMUNICATION.EVENTS.ON_START, `${error.message}`)
      );
    }
  };

  setTitle = (title: string) => {
    try {
      const eventDetails = {
        eventType: SF_COMMUNICATION.EVENTS.SET_TITLE,
        data: title,
      };
      window.parent.postMessage(eventDetails, window.configuration.IB_URL);
    } catch (error: any) {
      throw new Error(
        getErrorMessage(SF_COMMUNICATION.EVENTS.SET_TITLE, `${error.message}`)
      );
    }
  };

  setHeight = (height: number) => {
    try {
      const eventDetails = {
        eventType: SF_COMMUNICATION.EVENTS.SET_HEIGHT,
        data: height,
      };
      window.parent.postMessage(eventDetails, window.configuration.IB_URL);
    } catch (error: any) {
      throw new Error(
        getErrorMessage(SF_COMMUNICATION.EVENTS.SET_HEIGHT, `${error.message}`)
      );
    }
  };

  setContainerConfig = (containerConfig: IContainerConfig) => {
    try {
      const eventDetails = {
        eventType: SF_COMMUNICATION.EVENTS.SET_CONTAINER_CONFIG,
        data: containerConfig,
      };
      window.parent.postMessage(eventDetails, window.configuration.IB_URL);
    } catch (error: any) {
      throw new Error(
        getErrorMessage(
          SF_COMMUNICATION.EVENTS.SET_CONTAINER_CONFIG,
          `${error.message}`
        )
      );
    }
  };

  showModal = (modalData: IModalData) => {
    try {
      const eventDetails = {
        eventType: SF_COMMUNICATION.EVENTS.SHOW_MODAL,
        data: modalData,
      };
      window.parent.postMessage(eventDetails, window.configuration.IB_URL);
    } catch (error: any) {
      throw new Error(
        getErrorMessage(SF_COMMUNICATION.EVENTS.SHOW_MODAL, `${error.message}`)
      );
    }
  };
}

window.onStart_callback = (startupData: string) => {
  const event = new CustomEvent("onStartCallbackEvent", {
    detail: JSON.parse(startupData) as IStartupData,
  });
  window.dispatchEvent(event);
};

window.showModal_callback = (isPrimaryButtonClicked: boolean) => {
  const event = new CustomEvent("onShowModalCallbackEvent", {
    detail: isPrimaryButtonClicked,
  });
  window.dispatchEvent(event);
};

/* React listner to listen the method executed from IB */
window.addEventListener("message", function (event: any) {
  if (
    event.origin?.toLowerCase() !== window.configuration.IB_URL?.toLowerCase()
  ) {
    return;
  }
  const { method, data }: { method: string; data: any } = event?.data ?? {};
  switch (method) {
    case SF_COMMUNICATION.METHODS.ON_START_CALLBACK:
      (window as any)[method](JSON.stringify(data));
      break;
    case SF_COMMUNICATION.METHODS.SHOW_MODAL_CALLBACK:
      (window as any)[method](data);
      break;
    default:
      break;
  }
});
